export default {
  courses: [
    {
      'urllink': 'http://www.stuq.com/course/45',
      'pc_imgUrl': require('../../static/img/course/course_mvp.jpg'),
      'm_imgUrl': require('../../static/img/course/m_course_mvp.jpg'),
      'title': '微软 MVP 亲传 72 课时，让你快速玩转大数据',
      'profile': '从零开始，包括 R 语言入门、数据基本统计分析、数据探索、数据可视化、数据建模、模型评估等内容...',
      'dateAndLoc': '2017-8-18 ／ 谢佳标'
    },
    {
      'urllink': 'http://www.stuq.com/course/30',
      'pc_imgUrl': require('../../static/img/course/course_python.jpg'),
      'm_imgUrl': require('../../static/img/course/m_course_python.jpg'),
      'title': 'Python 机器学习从入门到精通 60 讲',
      'profile': 'Python 是一门易学易用的编程语言，Python 3 的成熟让这门语言焕发出更多可能性，Python 在整个...',
      'dateAndLoc': '2017-09-10 ／ 韦玮'
    },
    {
      'urllink': 'http://www.stuq.com/course/74',
      'pc_imgUrl': require('../../static/img/course/course_tensorflow.jpg'),
      'title': 'TensorFlow实战',
      'profile': 'TensorFlow 是目前最流行的深度学习框架，没有之一！TensorFlow 由 Google 大脑小组的研究员和工程...',
      'dateAndLoc': '2017-09-02 / 郑泽宇'
    },
    {
      'urllink': 'http://www.stuq.com/course/35',
      'pc_imgUrl': require('../../static/img/course/course_qianduan.jpg'),
      'title': '从前端小工到 BAT 中高级工程师的必备技能',
      'profile': '本课程主要面向 1-3 年工作经验的前端开发同学，讲师通过自己的经验总结，梳理了一线大型互联网公...',
      'dateAndLoc': '2017-08-05 / 杨文坚'
    },
    {
      'urllink': 'http://www.stuq.com/course/60',
      'pc_imgUrl': require('../../static/img/course/course_mySql.jpg'),
      'title': 'Oracle&MySQL 从入门到精通',
      'profile': '本系列课程从数据库的基本规范开始讲解，帮助大家了解数据库行业的规范和标准，对企业级安装部署...',
      'dateAndLoc': '2017-08-16 ／ 杨建荣'
    },
    {
      'urllink': 'http://www.stuq.com/course/70',
      'pc_imgUrl': require('../../static/img/course/course_coding.jpg'),
      'title': '算法与数据结构—高级程序员必备的内功心法',
      'profile': '课程会结合覃超老师在硅谷三年多面试 300+ 人的经历，以及后续几年来的自我总结和授课经验,集中剖析...',
      'dateAndLoc': '2017-08-15 / 覃超'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/util/course.js